import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Settings,
  TrendingUp
} from "lucide-react";
import ClinicPaymentConfig from './ClinicPaymentConfig';
import ClinicPaymentReports from './ClinicPaymentReports';

const ClinicPayments = () => {
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(tabFromUrl === 'settings' ? 'settings' : 'reports');

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Page Header - Matching Dashboard Style */}
      <div className="mb-2">
        <h1 className="font-montserrat text-slate-900 tracking-tight text-lg sm:text-2xl" style={{ fontWeight: 700 }}>
          Payments
        </h1>
        <p className="text-slate-600 font-inter mt-1 text-xs sm:text-sm">
          Manage your payment settings and view transaction reports
        </p>
      </div>

      {/* Main Content */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2 max-w-md">
          <TabsTrigger value="reports" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Reports
          </TabsTrigger>
          <TabsTrigger value="settings" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Settings
          </TabsTrigger>
        </TabsList>

        <TabsContent value="reports" className="mt-6">
          <ClinicPaymentReports />
        </TabsContent>

        <TabsContent value="settings" className="mt-6">
          <ClinicPaymentConfig />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ClinicPayments;
